import { render, staticRenderFns } from "./iconsChat.vue?vue&type=template&id=6c20e9df&scoped=true&functional=true&"
var script = {}
import style0 from "./iconsChat.vue?vue&type=style&index=0&id=6c20e9df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6c20e9df",
  null
  
)

export default component.exports